import wixWindow from 'wix-window';

let formFactor = wixWindow.formFactor; // "Mobile"

$w.onReady(function () {
	if (formFactor === "Mobile") {
		$w("#buttonMobile").show()
		$w("#image1Mobile").show()
		$w("#slideshow2Mobile").show()
		$w("#image3Mobile").show()
		$w("#image4Mobile").show()
		$w("#image5Mobile").show()
		$w("#button6Mobile").show()
		$w("#button7Mobile").show()
		$w("#button8Mobile").show()
		$w("#imageTemp1M").show()
		$w("#imageTemp2M").show()
		$w("#imageTemp3M").show()
		$w("#imageTemp4M").show()
		$w("#imageTemp5M").show()
		$w("#imageTemp6M").show()
		$w("#button9Mobile").show()
		$w("#button10Mobile").show()

	}
});